import React, { useEffect, useState } from 'react';
import * as Yup from 'yup';
import { HStack, Box, Text, Button, Input } from '@chakra-ui/react';
import { toast } from "react-toastify";
import Select from 'react-select';
import { Formik } from 'formik';
import axios from 'axios';
import { fetchWrapper } from '../../helpers';
import { InputText } from '../../components/form';


const VariableApi = () => {
    const [formData, setFormData] = useState({
        template: '',
        to: '',
        message: '',
        email: '',
        type: '1',
        channel: '',
        variables: [
            {
                key: '',
                value: '',
            }
        ],
    });

    const FormSchema = Yup.object().shape({
        template: Yup.string()
            .required('Template is required'),

        to: Yup.string()
            .required('Mobile number is required'),

        variables: Yup.array().of(
            Yup.object().shape({
                key: Yup.string(),
                value: Yup.string()
                    .required('Value is required')
            })
        ),

        email: Yup.string()
            .email('Invalid email format')
            .nullable()
            .test('conditional-email', 'Email is required for this template', function (value) {
                const { template } = this.parent;
                // If the template requires email, make it required
                // You can add your logic to check which templates require email
                const requiresEmail = false; // Replace with your logic
                return !requiresEmail || !!value;
            }),

        channel: Yup.string()
            .required('Preferred channel is required'),

        message: Yup.string()
            .required('Message is required')
    });
    const [templateOptions, setTemplateOptions] = useState([]);
    const [channelOptions, setChannelOptions] = useState([]);
    const [slecetedTemplate, setSlecetedTemplate] = useState({});
    const [loading, setLoading] = useState(false);
    const [selectedTemplateMessage, setSelectedTemplateMessage] = useState('');
    const [selectedOption, setSelectedOption] = useState({});
    const user = localStorage.getItem("customer_id");


    const extractVariablesFromMessage = (message) => {
        const regex = /\$([a-zA-Z_][a-zA-Z0-9_]*)/g;
        const matches = message.match(regex) || [];
        return matches.map(match => ({
            key: match.substring(1), // Remove the $ prefix
            value: ''
        }));
    };

    const TemplateList = async () => {
        try {
            const url = `${process.env.REACT_APP_API_URL}/template-message/list?customer_id=${process.env.REACT_APP_CUSTOMER_ID}`;
            const data = await fetchWrapper.get(url);

            let transformedData = data.data.map((item) => ({
                label: item?.name,
                value: item?.name,
                message: item?.message,
                ...item
            }));
            setTemplateOptions(transformedData);
        } catch (error) {
            console.error('Error fetching templates:', error);
            toast('Error fetching templates', { type: 'error' });
        }
    };


    const ChannelList = async () => {
        try {
            const url = `${process.env.REACT_APP_API_URL}/channel/list`;
            const data = await fetchWrapper.get(url);
            let transformedData = data.data.map((item) => ({
                label: item?.name,
                value: item?.name
            }));
            setChannelOptions([...transformedData, { label: "Smart Routing", value: "smart" }, { label: "Custom Routing", value: "custom" }]);
        } catch (error) {
            console.error('Error fetching channels:', error);
        }
    };

    useEffect(() => {
        TemplateList();
        ChannelList();
    }, []);



    const handleSelectChange = (field, option) => {
        setSelectedOption(option);
        if (field === 'template' && option) {
            const selectedTemplate = templateOptions.find(t => t.value === option.value);

            if (selectedTemplate) {
                setSelectedTemplateMessage(selectedTemplate.message);
                setSlecetedTemplate(selectedTemplate)

                const variables = extractVariablesFromMessage(selectedTemplate.message);
                setFormData(prev => ({
                    ...prev,
                    [field]: option.value,
                    message: selectedTemplate.message,
                    variables: variables
                }));
            }
        } else {
            setFormData(prev => ({
                ...prev,
                [field]: option ? option.value : ''
            }));

        }
    };




    const handleVariableChange = (index, field, value) => {
        const updatedVariables = formData.variables.map((variable, i) =>
            i === index ? { ...variable, [field]: value } : variable
        );

        // Update the message with the new variable values
        let updatedMessage = selectedTemplateMessage;
        updatedVariables.forEach(variable => {
            if (variable.value) {
                updatedMessage = updatedMessage.replace(
                    `$${variable.key}`,
                    variable.value
                );
            }
        });

        setFormData(prev => ({
            ...prev,
            variables: updatedVariables,
            message: updatedMessage
        }));
    };

    const onSubmit = async (values, { setSubmitting, resetForm, setStatus }) => {
        // Old code
        const variablesObject = {};
        values.variables.forEach(variable => {
            if (variable.key && variable.value) {
                variablesObject[variable.key] = variable.value;
            }
        });
        const payload_with_custom = {
            "to": values.to,
            // "trans_type": slecetedTemplate?.MessageTemplateType?.message_type_id,
            ...variablesObject,
            // "preferred_channel": values?.channel,
            "email": values.email,
            "message_template_id": slecetedTemplate?.id
        }
        const payload_without_custom = {
            "to": values.to,
            // "trans_type": slecetedTemplate?.MessageTemplateType?.message_type_id,
            ...variablesObject,
            "preferred_channel": values?.channel,
            "email": values.email,
            "message_template_id": slecetedTemplate?.id
        }


        const payload = (selectedOption?.value === "custom" || selectedOption?.value === 'smart') ? payload_with_custom : payload_without_custom;

        try {
            setLoading(true)
            let url = `${process.env.REACT_APP_SEND_API_URL}/v2/send`;
            let url_api_key = `${process.env.REACT_APP_API_URL}/customer/by-id?id=${process.env.REACT_APP_CUSTOMER_ID}`;
            let res = await fetchWrapper.get(url_api_key);

            if (res.status) {
                let config = {
                    method: 'post',
                    maxBodyLength: Infinity,
                    url: url,
                    headers: {
                        'Content-Type': 'application/json',
                        'x-api-key': res?.data?.api_key,
                        'host': "xnotify.ai"
                    },
                    data: payload
                };
                await axios.post(url, payload, config);
                setLoading(false)
                toast('Message has been sent', { type: 'info' });

            } else {
                toast.error('Some thing went wrong', { type: 'error' });


            }


        } catch (error) {
            console.log(error.response.data.message)
            setLoading(false)
            console.error('Error:', error);
            toast(error?.response?.data?.message, { type: 'error' });
        } finally {
            setLoading(false)
        }
    };

    return (


        // <Box >
        <div className="sms_body_section">
            <HStack justifyContent="space-between">
                <Box width="100%">
                    <Box>
                        <Text fontSize="32px" fontWeight="300" color="#000000" my="0px" fontFamily="'Open Sans', sans-serif">
                            Send Message
                        </Text>
                    </Box>

                    <Formik
                        enableReinitialize
                        validationSchema={FormSchema}
                        initialValues={formData}
                        onSubmit={onSubmit}
                    >
                        {({ errors, touched, handleSubmit }) => (
                            <form onSubmit={handleSubmit}>
                                <Box mb="10px">
                                    <Text fontSize="16px" fontWeight="400" mb="5px">Message Template <span style={{ color: "red" }}>*</span></Text>
                                    <Select

                                        options={templateOptions}
                                        value={templateOptions.find(option => option.value === formData.template)}
                                        onChange={(option) => handleSelectChange('template', option)}
                                        placeholder="Select Template"
                                        className={errors.template && touched.template ? 'is-invalid' : ''}
                                    />
                                    {errors.template && touched.template && (
                                        <Text color="red.500" fontSize="sm" mt={1}>
                                            {errors.template}
                                        </Text>
                                    )}
                                </Box>

                                {formData.variables.length > 0 && (
                                    <>
                                        <Text fontSize="16px" fontWeight={400}>Variables <span style={{ color: "red" }}>*</span></Text>
                                        {formData.variables.map((variable, index) => (
                                            <HStack key={index} w="100%" mt="5px" alignItems="baseline">
                                                <Box w="50%">
                                                    <Input
                                                        value={variable.key}
                                                        isReadOnly
                                                        placeholder="Variable"
                                                        bg="gray.100"
                                                    />
                                                </Box>
                                                <Box w="50%">
                                                    <Input
                                                        value={variable.value}
                                                        onChange={(e) => handleVariableChange(index, 'value', e.target.value)}
                                                        placeholder="Value"
                                                        className={
                                                            errors.variables?.[index]?.value &&
                                                                touched.variables?.[index]?.value ? 'is-invalid' : ''
                                                        }
                                                    />
                                                    {errors.variables?.[index]?.value &&
                                                        touched.variables?.[index]?.value && (
                                                            <Text color="red.500" fontSize="sm" mt={1}>
                                                                {errors.variables[index].value}
                                                            </Text>
                                                        )}
                                                </Box>
                                            </HStack>
                                        ))}
                                    </>
                                )}
                                <Box mb="10px" mt="10px">
                                    <Text fontSize="16px" fontWeight={400} mb="5px">Preferred Channel <span style={{ color: "red" }}>*</span></Text>
                                    <Select
                                        options={channelOptions}
                                        value={channelOptions.find(option => option.value === formData.channel)}
                                        onChange={(option) => handleSelectChange('channel', option)}
                                        placeholder="Select Channel"
                                        className={errors.channel && touched.channel ? 'is-invalid' : ''}
                                    />
                                    {errors.channel && touched.channel && (
                                        <Text color="red.500" fontSize="sm" mt={1}>
                                            {errors.channel}
                                        </Text>
                                    )}
                                </Box>
                                <Box mb="10px" mt="10px">
                                    <Text fontSize="16px" fontWeight={400} mb="5px">Mobile Number <span style={{ color: "red" }}>*</span></Text>
                                    <InputText
                                        name="to"
                                        title=""
                                        placeholder="Enter Phone Number starting with 92 or country code"
                                    />

                                </Box>
                                <Box mb="10px">
                                    <InputText
                                        name="email"
                                        title="E-Mail (Optional)"
                                        placeholder="Please Enter Email ID"
                                    />
                                </Box>


                                <Button
                                    isLoading={loading}
                                    py="10px"
                                    px="25px"
                                    color="#fff"
                                    bg="#2563eb"
                                    fontSize="14px"
                                    fontWeight="500"
                                    fontFamily="'Open Sans', sans-serif"
                                    mb={4}
                                    style={{ width: "100%" }}
                                    type="submit"
                                >
                                    Send Test Message
                                </Button>
                            </form>
                        )}
                    </Formik>
                </Box>
            </HStack>
        </div>
        // </Box>

    );
};

export default VariableApi;